export const unsubscribeStyles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    fontFamily: "Inter",
  },
  nodeInitial: {
    position: "relative",
    top: "20px",
    left: "10px",
    color: "#797b8c",
    textAlign: "center",
    paddingRight: "35px",
  },
  bottomRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    "&:hover": {
      cursor: "pointer",
    },
  },
  nodeBody: {
    margin: 0,
    padding: 0,
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    height: "30px",
    minWidth: "90px",
    fontSize: "16px",
    color: "#fff",
    backgroundColor: "#FB4B54",
    borderRadius: "20px",
    marginBottom: "30px",
  },
  titleName: {
    fontSize: "12px",
    fontFamily: "Inter",
    fontWeight: 525,
  },
  iconButton: {
    height: "20px",
    width: "20px",
    marginLeft: "5px",
    marginRight: "4px",
    "&:hover": {
      backgroundColor: "#FB4B54",
    },
  },
  nodeIcon: {
    fontSize: "18px",
    color: "#fff",
    fontWeight: 600,
  },
  addIcon: {
    fontSize: "14px",
    height: "20px",
    width: "20px",
    color: "#22304a",
    borderRadius: "50%",
    backgroundColor: "white",
    marginLeft: "4px",
    transition: "visibility 0s, color 0.2s",
    position: "relative",
    bottom: "13px",
    "&:hover": {
      color: "blue",
    },
  },
  leftHandle: {
    background: "#566d89",
    opacity: "0",
    left: "2px",
    top: "-11px",
    position: "relative",
  },
  rightHandle: {
    background: "#566d89",
    opacity: "0",
    top: "4px",
    left: "7px",
    position: "relative",
  },
};
